module.exports = __webpack_public_path__ + "static/media/ads (4).bc18e47c.png";